<template>
    <div class="main-wrapper px-3">
        <!-- Loading -->
        <div
            v-if="isPromotionsFetching"
            class="d-flex justify-content-center align-items-center"
            style="gap: 8px; min-height: 200px;"
        >
            <van-loading type="spinner" />
            Loading...
        </div>

        <!-- No promotions -->
        <template v-else-if="!promotions.length">
            <NoPromotions />
        </template>

        <!-- Promotion list -->
        <template v-else>
            <PromotionCard
                v-for="(promotion, index) in promotions"
                :key="index"
                :promotion="promotion"
            />
        </template>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import NoPromotions from './components/NoPromotions.vue';
import PromotionCard from './components/PromotionCard.vue';

export default {
    components: {
        PromotionCard,
        NoPromotions
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapState('promotions', ['promotions', 'isPromotionsFetching'])
    },
    methods: {
        ...mapActions(['fetchUser']),
        ...mapActions('promotions', ['fetchPromotions']),
    },
    async mounted() {
        this.$store.commit("setLoading", true);

        try {
            const authUser = await this.fetchUser();

            if (!authUser) {
                this.$router.push('/auth/login');
                return;
            }

            await this.fetchPromotions();
        } finally {
            this.$store.commit("setLoading", false);
        }
    }

};
</script>
<style scoped></style>